export const HideBalance: React.FC = () => {
    return (
      <div className="w-1/2 h-[43px] relative animate-pulse">
        <div className="w-[100px] h-2 right-0 top-[8px] absolute bg-gray-300 rounded-[17px]" />
        <div className="w-[80px] h-2 right-0 top-[25px] absolute bg-gray-300 rounded-[17px]" />
      </div>
    );
  }